import { z } from "zod";

import { ERROR_TYPE } from "@/utils";
import { TokenPurpose } from "@/enum";

const { REQUIRED } = ERROR_TYPE;

/**
 * Form shape of the forgotten-password page. Like the invitation SetPassword page it is a single
 * password field — the live complexity meter (`PasswordComplexityField`) gates submission, so
 * there is no confirm-password field and no separate regex check here.
 */
export const ChangePasswordSchema = z.object({
	password: z.string().min(1, { message: REQUIRED }).trim(),
});

export const ChangePasswordRequestSchema = z.object({
	password: z.string().min(8),
	token: z.string().min(1, { message: REQUIRED }),
	purpose: z.nativeEnum(TokenPurpose),
});

export const createChangePasswordRequestBody = (
	values: ChangePasswordType,
	token: string
): ChangePasswordBody => ({
	password: values.password,
	token,
	purpose: TokenPurpose.FORGOTTEN_PASSWORD,
});

export type ChangePasswordType = z.infer<typeof ChangePasswordSchema>;
export type ChangePasswordBody = z.infer<typeof ChangePasswordRequestSchema>;
